<template>
  <v-app id="inspire">
    <router-view></router-view>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  created(){
    document.title = "Student Finance Services Portal"
  }
}
</script>
